export default __webpack_public_path__ + "static/media/gamechoice.c6ca4ade.jpg";